import { useMemo } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { spaceApi } from '../services/api';
import { useSpaceId } from '../contexts/SpaceContext';

export function useMcpAuthStatus(
  serverId: string | undefined,
  returnUrl?: string,
) {
  const spaceId = useSpaceId();
  const api = useMemo(() => spaceApi(spaceId).mcpServers, [spaceId]);
  return useQuery({
    // Key on returnUrl too — the backend bakes it into the returned
    // authorizationUrl, so different returnUrls yield different cache entries.
    queryKey: ['space', spaceId, 'mcp-servers', serverId, 'auth-status', returnUrl ?? ''],
    queryFn: () => api.authStatus(serverId!, returnUrl),
    enabled: !!serverId,
  });
}

/**
 * Force a re-check of a server's auth status — used by the manual "Check
 * again" button as a fallback when the WebSocket connected event hasn't
 * arrived yet.
 */
export function useInvalidateMcpAuthStatus() {
  const spaceId = useSpaceId();
  const qc = useQueryClient();
  return (serverId: string) =>
    qc.invalidateQueries({
      queryKey: ['space', spaceId, 'mcp-servers', serverId, 'auth-status'],
    });
}
